import React from "react";
import "./AboutTitle.css"; 

const AboutTitle = () => {
  return (
    <div className="about-main-page-1">
      <h1>Embodied Excellence</h1>
      <p>The Essence of Snáithe</p>
    </div>
  );
};

export default AboutTitle;
